module.exports = __webpack_public_path__ + "img/nature.92760707.jpg";